// Einwilligungen fuer optionale Google-Dienste (TDDDG § 25, DSGVO Art. 6 Abs. 1 lit. a).
// Ohne gespeicherte Zustimmung werden weder das Google-Ads-Tag noch reCAPTCHA geladen.
// Gespeichert wird nur im lokalen Browserspeicher, nichts geht an den Server.
import { useEffect, useState } from 'react';

const KEY = 'consent_v1';
const EVENT = 'consent-changed';

export const readConsent = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      ads: parsed.ads === true,
      recaptcha: parsed.recaptcha === true,
      ts: parsed.ts || null,
    };
  } catch (e) {
    return null;
  }
};

export const saveConsent = (partial) => {
  const current = readConsent() || { ads: false, recaptcha: false };
  const next = { ...current, ...partial, ts: new Date().toISOString() };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    // Speicher gesperrt: Zustimmung gilt nur bis zum Neuladen
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
  // Widerruf: bereits geladene Google-Skripte lassen sich nur durch Neuladen sicher entfernen
  if ((current.ads && !next.ads) || (current.recaptcha && !next.recaptcha)) {
    window.location.reload();
  }
  return next;
};

// Banner wieder oeffnen (Link "Cookie-Einstellungen" im Footer)
export const reopenConsent = () => {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { reopen: true } }));
};

export const useConsent = () => {
  const [consent, setConsent] = useState(readConsent());
  const [reopened, setReopened] = useState(false);

  useEffect(() => {
    const onChange = (e) => {
      if (e.detail && e.detail.reopen) {
        setReopened(true);
        return;
      }
      setConsent(readConsent());
      setReopened(false);
    };
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, []);

  return { consent, reopened };
};
